import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import {
  CUSTOMER_CARE_EMAIL,
  CUSTOMER_CARE_EMAIL_MAILTO,
  LOANDEPOT_SUPPORT_DISPLAY,
  LOANDEPOT_SUPPORT_TEL,
  TCPA_CONSENT,
} from '@ld.consumer-portal/constants';
import { PlatformService } from '@ld.consumer-portal/utils';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export interface EConsentResult {
  tcpaConsented: boolean;
}

@Component({
  selector: 'ld-econsent-disclosure-modal',
  imports: [MatIconModule, TranslocoDirective, BaseModalComponent],
  templateUrl: './econsent-disclosure-modal.component.html',
  styleUrl: './econsent-disclosure-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EconsentDisclosureModalComponent {
  private readonly translocoService = inject(TranslocoService);
  private readonly platformService = inject(PlatformService);

  protected readonly isNativeMobile = this.platformService.isNativeMobile;

  readonly showTcpaCheckbox = input(false);

  readonly consent = output<EConsentResult>();

  readonly decline = output<void>();

  protected readonly showDeclineWarning = signal(false);

  protected readonly tcpaChecked = signal(true);

  protected readonly tcpaDisclosureText = computed(() => this.translocoService.translate(TCPA_CONSENT.disclosure));

  protected readonly supportPhoneDisplay = `${LOANDEPOT_SUPPORT_DISPLAY} Ext. 6789`;
  protected readonly supportPhoneTel = LOANDEPOT_SUPPORT_TEL;
  protected readonly customerCareEmail = CUSTOMER_CARE_EMAIL;
  protected readonly customerCareEmailMailto = CUSTOMER_CARE_EMAIL_MAILTO;

  protected onConsent(): void {
    this.consent.emit({ tcpaConsented: this.showTcpaCheckbox() ? this.tcpaChecked() : false });
  }

  protected onDecline(): void {
    if (!this.showDeclineWarning()) {
      this.showDeclineWarning.set(true);
      return;
    }
    this.decline.emit();
  }

  protected onCancel(): void {
    this.showDeclineWarning.set(false);
  }

  protected toggleTcpa(): void {
    this.tcpaChecked.update((v) => !v);
  }
}
